import React, { Children, cloneElement, FC, ReactElement } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import { ICardButtonProps } from './CardButton'

type TDirection = 'row' | 'column'

interface ICardButtonGroupProps {
  children: JSX.Element[]
  value?: string

  /**
   * @default 'row'
   */
  direction?: TDirection
  onClick: (newValue: string) => void
}

const useStyles = makeStyles<null, { childCount: number; direction: TDirection }>(() => ({
  root: {
    // Adds 10px gap between buttons
    width: ({ childCount, direction }) => {
      if (direction === 'row') {
        return `calc(${100 / childCount}% - 10px)`
      }
      return '100%'
    },
    marginBottom: ({ direction }) => (direction === 'column' ? '10px' : 'initial'),
  },
}))

export const CardButtonGroup: FC<ICardButtonGroupProps> = ({
  children: childrenProp,
  direction: directionProp = 'row',
  onClick: onClickProp,
  value: valueProp,
}) => {
  const [selected, setSelected] = React.useState<string | undefined>(valueProp)
  const usedClasses = useStyles({ childCount: childrenProp.length, direction: directionProp })
  const handleClick = (value: string) => {
    setSelected(value)
    onClickProp(value)
  }

  return (
    <Box display='flex' justifyContent='space-between' py={1} flexDirection={directionProp}>
      {Children.map(childrenProp, (child: ReactElement<ICardButtonProps>) =>
        cloneElement(child, {
          selected,
          className: usedClasses.root,
          onClick: handleClick,
        })
      )}
    </Box>
  )
}
